import PropTypes from "prop-types";
import { Col, Form, Nav } from "react-bootstrap";
import { useState, useEffect } from "react";

export function Pager(props) {
  const [pageInput, setPageInput] = useState(props.page);

  useEffect(() => {
    setPageInput(props.page);
  }, [props.page]);

  const handlePageSizeChange = (event) => {
    let newPageSize = Number(event.target.value);
    props.onPageSizeChange(props.page, newPageSize);
  };

  const handlePageChange = (value) => {
    const newPage = getValidPageValue(value);
    props.onPageChange(newPage, props.pageSize);
  };

  const handlePageInputBlur = () => {
    handlePageChange(Number(pageInput));
  };

  const handlePageInputKeyDown = (e) => {
    if (e.key === "Enter") {
      handlePageChange(Number(pageInput));
      e.target.blur();
    }
  };

  const handlePreviousPage = () => {
    handlePageChange(props.page - 1);
  };

  const handleNextPage = () => {
    handlePageChange(props.page + 1);
  };

  const getValidPageValue = (pageValue) => {
    return clamp(1, pageValue, props.maxPages);
  };

  const clamp = (min, value, max) => {
    return Math.max(Math.min(max, value), min);
  };

  return (
    <Nav aria-label="Page navigation row">
      <Col xs={6} sm={3} className="form-group text-start">
        <label className="inline">Go to page:</label>
        <Form.Control
          type="number"
          min={1}
          max={props.maxPages}
          value={pageInput}
          onChange={(e) => setPageInput(e.target.value)}
          onBlur={handlePageInputBlur}
          onKeyDown={handlePageInputKeyDown}
          className="form-control page-select wide-input"
        />
      </Col>

      <Col xs={6} sm={3} className="form-group text-end">
        <label className="inline">Rows per page:</label>
        <Form.Select
          onChange={handlePageSizeChange}
          value={props.pageSize}
          className="form-control page-select wide-input"
        >
          {props.pageSizeOptions.map((s) => (
            <option value={s} key={s}>
              {s}
            </option>
          ))}
        </Form.Select>
      </Col>

      <Col xs={6} sm={3} className="hidden-xs pagination-counts text-end">
        <span className="current-page">
          {(props.page - 1) * props.pageSize + 1} -{" "}
          {Math.min(props.page * props.pageSize, props.maxItems)}
        </span>{" "}
        of <span className="total-count">{props.maxItems}</span>
      </Col>

      <Col xs={6} sm={3}>
        <ul className="pagination">
          <li>
            <button
              onClick={handleNextPage}
              hidden={props.page === props.maxPages}
            >
              &gt;
            </button>
          </li>
          <li>
            <button onClick={handlePreviousPage} hidden={props.page === 1}>
              &lt;
            </button>
          </li>
        </ul>
      </Col>
    </Nav>
  );
}

Pager.propTypes = {
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  maxPages: PropTypes.number.isRequired,
  maxItems: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  pageSizeOptions: PropTypes.array,
};

Pager.defaultProps = {
  pageSizeOptions: [10, 25, 50],
};
